function close(modal) {
    modal.classList.remove('fade-in');
    modal.classList.add('fade-out');

    modal._lastCloser = setTimeout(() => {
        modal.classList.remove('fade-out');
        modal.classList.remove('visible');
    }, 300);
}

const setupModals = new Set();

export function openModal(id) {
    const modal = document.querySelector('div.modal[id=' + JSON.stringify(id) + ']');
    if (!modal)  {
        console.error('No modal found for id', id);
        return;
    }

    if (modal._lastCloser) {
        clearTimeout(modal._lastCloser);
    }

    modal.classList.add('visible');
    setTimeout(() => {
        modal.classList.add('fade-in');
    });

    if (setupModals.has(modal)) return;

    const closer = modal.querySelector('.modal-closer');
    if (closer) closer.addEventListener('click', () => close(modal));

    const backDrop = modal.querySelector('.modal-backdrop');
    if (backDrop) backDrop.addEventListener('click', () => close(modal));

    setupModals.add(modal);
}
